'use client';

import { useTranslations } from 'next-intl';
import CustomLink from 'components/shared/CustomLink';
import type { CustomLinkProps } from 'components/shared/CustomLink';
import {
  useBloodVisionBooking,
  useBookBloodVisionInApp,
} from './hooks/useBloodVisionBooking';
import styles from './BookTestCta.module.css';

export const BookTestCta = ({
  href = '/blood-vision/buy',
  className,
}: {
  href?: CustomLinkProps['href'];
  className?: string;
}) => {
  const t = useTranslations('common');
  const booking = useBloodVisionBooking();
  const bookInApp = useBookBloodVisionInApp();

  if (booking === 'web') {
    return (
      <CustomLink href={href} className={className}>
        {t('header.bookTest')}
      </CustomLink>
    );
  }

  if (booking === 'app') {
    return (
      <button
        type="button"
        onClick={bookInApp}
        className={[styles.appButton, className].filter(Boolean).join(' ')}
      >
        {t('header.bookTest')}
      </button>
    );
  }

  return null;
};

export const ComingSoonEyebrow = () => {
  const tBloodVision = useTranslations('bloodVision');
  const booking = useBloodVisionBooking();
  if (booking) return null;
  return (
    <p className={styles.comingEyebrow}>{tBloodVision('hero.comingSoon')}</p>
  );
};
